import { Authenticator } from 'aws-amplify-react';
import React from 'react';
import CustomConfirmSignIn from './CustomConfirmSignIn';
import CustomConfirmSignUp from './CustomConfirmSignUp';
import CustomForgotPassword from './CustomForgotPassword';
import CustomGreetings from './CustomGreetings';
import CustomSignIn from './CustomSignIn';
import CustomSignUp from './CustomSignUp';
import CustomVerifyContact from './CustomVerifyContact';

export default ({ onStateChange }) => (
    <Authenticator hideDefault={true} onStateChange={onStateChange}>
        <CustomSignIn key="1" />
        <CustomConfirmSignIn key="2" />
        <CustomVerifyContact key="3" />
        <CustomSignUp key="4" />
        <CustomConfirmSignUp key="5" />
        <CustomForgotPassword key="6" />
        <CustomGreetings key="7" />
    </Authenticator>
);



// WEBPACK FOOTER //
// ./src/components/cognito/Authenticator.tsx